import { IconCheckSquare, IconEnvelopeAlt } from '@maia/icons';
import { PageHeader, InfoCard, ButtonLink } from '@maia/ui';
import { createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/claims/new/_layout/$customer/success',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = useParams({
    from: '/_authenticated/claims/new/_layout/$customer/success',
  });

  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De claim is succesvol ingediend!"
        description="Er gebeuren allemaal slimme dingen"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Bevestigings email naar de klant"
              description="Binnen enkele minuten ontvangt de klant een email met een overzicht van de ingediende claim."
            />
          </li>
          <li>
            <InfoCard
              icon={IconCheckSquare}
              title="Schadebehandelaren ontvangen claim"
              description="Er staat een team van schade experts klaar om deze claim zo snel mogelijk op te pakken"
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          <ButtonLink
            to="/customers/$guid"
            params={{ guid: params.customer }}
            intent="primary"
          >
            Terug naar klant
          </ButtonLink>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </div>
  );
}
